import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';
import { useTheme } from '../context/ThemeContext';

const LanguageToggle = () => {
  const { language, toggleLanguage } = useLanguage();
  const { theme } = useTheme();
  const isDark = theme === 'dark';

  return (
    <motion.button
      onClick={toggleLanguage}
      className={`relative px-2.5 py-1 rounded-lg border transition-all duration-200 ${
        isDark
          ? 'bg-white/5 border-white/20 hover:border-afsc-gold/50 text-white/90'
          : 'bg-afsc-charcoal/5 border-afsc-charcoal/20 hover:border-afsc-gold/50 text-afsc-charcoal/90'
      }`}
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
      aria-label="Toggle language"
    >
      <span className="text-xs font-medium">
        {language === 'en' ? 'EN' : 'AR'}
      </span>
    </motion.button>
  );
};

export default LanguageToggle;

